export const common = {
  "home.awards.title": "Prix et distinctions",
  "home.awards.pause": "Mettre le défilement des prix en pause",
  "home.awards.play": "Reprendre le défilement des prix",
  "home.awards.financialAlgorithm": "Leader des algorithmes financiers",
  "home.awards.asiaPacificGold": "Marque leader du négoce d’or en Asie-Pacifique",
  "home.awards.preciousMetals": "Marque de confiance du négoce de métaux précieux",
  "home.awards.digitalFinance": "Contribution à l’innovation en finance numérique",
  "home.awards.quantitativeTrading": "Entreprise d’excellence en technologie de trading quantitatif",
   // Navigation
  'nav.home': 'Accueil',
  'nav.trading': 'Trading',
  'nav.markets': 'Marchés',
  'nav.news': 'Actualités',
  'nav.about': 'À propos',
  'nav.contact': 'Contact',
  'nav.login': 'Connexion',
  'nav.register': "S'inscrire",

  // Hero Section
  'hero.title': "Plateforme de trading premium d'or et d'argent",
  'hero.subtitle': "Société agréée de Hong Kong offrant un trading sécurisé et professionnel des métaux précieux pour les investisseurs européens",
  'hero.cta.start': 'Commencer à trader',
  'hero.cta.learn': 'En savoir plus',

  // Home
  'home.licenseHK': 'Autorisé à Hong Kong',
  'home.bankSec': 'Sécurité bancaire',
  'home.247s': 'Assistance 24h/24 et 7j/7',
  'home.global': 'Portée mondiale',
  'home.tradingPlat': 'Plateforme de trading',
  'home.tradingWith': 'Trader avec ',
  'home.exp': "Découvrez la plateforme de trading la plus avancée au monde, conçue pour le commerce des métaux précieux. MT5 offre des outils de niveau institutionnel, une exécution ultra-rapide et une analyse de marché complète.",
  'home.dlMT5': 'Télécharger MT5',
  'home.watchDemo': 'Regarder la démo',
  'home.tradingIns': 'Instruments de trading',
  'home.exeSpeed': "Vitesse d'exécution",
  'home.mktAccess': 'Accès au marché',
  'home.uptime': 'Disponibilité',
  'home.allDevices': 'Disponible sur tous les appareils',
  'home.mktInt': 'Intelligence du marché',
  'home.mktInt.desc': 'Restez informé grâce aux événements économiques en temps réel et aux actualités du marché influençant le trading des métaux précieux',
  'home.lastUpdate': 'Dernière mise à jour',
  'home.ecoCal': 'Calendrier économique',
  'home.refresh': 'Actualiser',
  'home.currency': 'Devise',
  'home.events': 'Événements',
  'home.previous': 'Précédent',
  'home.forecast': 'Prévision',
  'home.actual': 'Actuel',
  'home.mktNews': 'Actualités du marché',
  'home.seeMore': 'Voir plus',
  'home.ecoData': 'Données économiques fournies par plusieurs prestataires financiers • Actualités de marchés issues de publications financières de premier plan',
  'home.ac': 'Graphiques avancés',
  'home.pta': 'Analyse technique professionnelle avec plus de 80 indicateurs et outils analytiques',
  'home.mpa': 'Accès multi-plateforme',
  'home.tsa': 'Tradez sans interruption sur ordinateur, web et mobile',
  'home.st': 'Trading sécurisé',
  'home.bls': 'Sécurité bancaire avec transmission et stockage des données cryptés',
  'home.247': 'Accès au marché 24h/24',
  'home.rtc': 'Accès continu aux marchés mondiaux des métaux précieux',
  'home.at': 'Trading automatisé',
  'home.ea': 'Expert Advisors (EAs) pour stratégies de trading algorithmiques et automatisées',
  'home.lfe': 'Exécution ultra-rapide',
  'home.ull': 'Exécution d’ordres à très faible latence avec spreads compétitifs',

  // Features
  'features.title': 'Pourquoi choisir notre plateforme',
  'features.security.title': 'Sécurité de niveau bancaire',
  'features.security.desc': 'Un chiffrement avancé et des protocoles de sécurité multicouches protègent vos investissements',
  'features.licensed.title': 'Entièrement agréée',
  'features.licensed.desc': 'Société réglementée à Hong Kong avec pleine conformité et transparence',
  'features.realtime.title': 'Trading en temps réel',
  'features.realtime.desc': 'Données de marché en direct et exécution instantanée pour des opportunités optimales',
  'features.support.title': 'Assistance 24h/24 et 7j/7',
  'features.support.desc': 'Équipe d’assistance multilingue professionnelle disponible à tout moment',
  'features.lmd': 'Données de marché en direct',
  'features.rtp': 'Prix des métaux précieux en temps réel',

  // Markets
  'markets.title': 'Prix du marché en direct',
  'markets.gold': 'Or',
  'markets.silver': 'Argent',
  'markets.platinum': 'Platine',
  'markets.palladium': 'Palladium',
  'markets.price': 'Prix',
  'markets.change': 'Changement',
  'markets.high': 'Plus haut 24h',
  'markets.low': 'Plus bas 24h',
  'markets.contractDetials': 'Détails du contrat',
  'markets.contractDetials.desc': 'Spécifications complètes et conditions de trading pour les métaux précieux',
  'markets.tradingExample': 'Exemple de trading',
  'markets.goldExample': 'Exemple de trading sur l’or',
  'markets.silverExample': 'Exemple de trading sur l’argent',
  'markets.instrument': 'Instrument',
  'markets.lotSize': 'Taille du lot',
  'markets.entPrice': "Prix d'entrée",
  'markets.marReq': 'Marge requise',
  'markets.pip': 'Valeur du pip',
  'markets.pmt': 'Trading de métaux précieux',
  'markets.ctt': 'Conditions et spécifications complètes pour le trading des métaux précieux. Comprenez les détails du contrat, les exigences de marge et la gestion des risques pour vos investissements en or et en argent.',
  'markets.vts': 'Voir les spécifications de trading',
  'markets.dcd': 'Télécharger les détails du contrat',
  'markets.ec': "Vitesse d'exécution",
  'markets.th': 'Heures de trading',
  'markets.ms': 'Spread minimum (pips)',
  'markets.ml': 'Effet de levier maximal',
  'markets.mr': 'Exigences de marge',
  'markets.lo': 'Options de levier et exigences de marge selon le type de compte',
  'markets.leverage': 'Effet de levier',
  'markets.margin': 'Marge',
  'markets.mind': 'Dépôt minimum',
  'markets.mc': 'Calculatrice de marge',
  'markets.gmc': 'Calcul de marge sur l’or',
  'markets.cp': 'Prix actuel',
  'markets.cv': 'Valeur du contrat',
  'markets.smc': 'Calcul de marge sur l’argent',
  'markets.rm': 'Gestion des risques',
  'markets.crm': 'Outils et stratégies complets de gestion des risques pour protéger vos investissements',
  'markets.rtg': 'Guide de tolérance au risque',
  'markets.rd': 'Avertissement sur les risques',
  'markets.tpm': 'Le trading des métaux précieux comporte un risque important de perte et peut ne pas convenir à tous les investisseurs. Les performances passées ne garantissent pas les résultats futurs.',
  'markets.lcw': "L'effet de levier peut jouer contre vous comme en votre faveur. Avant de trader, évaluez soigneusement vos objectifs d’investissement, votre expérience et votre tolérance au risque.",
  'markets.ysb': 'Vous devez être conscient de tous les risques liés au trading des métaux précieux et consulter un conseiller financier indépendant en cas de doute.',
  'markets.rfr': 'Lire la divulgation complète des risques',
  'markets.cra': 'Contacter un conseiller en risques',
  'markets.tho': 'Heures de trading',
  'markets.moh': 'Heures de fonctionnement du marché et calendrier des jours fériés pour le trading des métaux précieux',
  'markets.wts': 'Programme de trading hebdomadaire',
  'markets.note': 'Remarque',
  'markets.atad': 'Toutes les heures sont affichées en GMT+8. Le trading peut être suspendu pendant les jours fériés importants ou en période de forte volatilité.',
  'markets.hs': 'Calendrier des jours fériés',
  'markets.mclo': 'Marché fermé',
  'markets.eclo': 'Fermeture anticipée',
  'markets.hn': 'Avis de jours fériés',
  'markets.thm': 'Les heures de trading peuvent être ajustées pendant les jours fériés nationaux. Veuillez consulter nos annonces pour toute modification du calendrier.',
  'markets.cms': 'État actuel du marché',
  'markets.mac': 'Les marchés sont actuellement OUVERTS au trading',
  'markets.st': 'Heure du serveur (GMT+8)',
  'markets.ts': 'Spécifications de trading',
  'markets.dtc': 'Conditions et spécifications détaillées pour les instruments or et argent',
  'markets.msp': 'Spread minimum',
  'markets.minls': 'Taille de lot minimale',
  'markets.maxls': 'Taille de lot maximale',
  'markets.commission': 'Commission',
  'markets.sls': 'Swap Long/Court',
  'markets.in': 'Notes importantes',
  'markets.smv': 'Les spreads peuvent varier pendant les périodes de forte volatilité ou lors des annonces majeures',
  'markets.sra': 'Les taux de swap sont mis à jour quotidiennement et peuvent changer selon les conditions du marché',
  'markets.mlm': "L'effet de levier maximal peut être réduit lors d'événements économiques majeurs",
  'markets.ata': 'Toutes les heures sont affichées dans le fuseau horaire GMT+8',

  // News
  'news.title': 'Dernières actualités et analyses de marché',
  'news.subtitle': 'Restez informé grâce aux éclairages d’experts et aux mises à jour du marché',
  'news.readMore': 'Lire la suite',
  'news.category.analysis': 'Analyse de marché',
  'news.category.news': 'Dernière minute',
  'news.category.insights': 'Opinions d’experts',
  'news.category.education': 'Formation',
  'news.date': 'Publié',
  'news.author': 'Par',

  // Testimonials
  'home.partners.title': 'Nos partenaires',
  'home.partners.subtitle': 'Nous collaborons avec des fournisseurs mondiaux de premier plan en liquidité, technologie financière et infrastructure de trading.',
  'testimonials.title': 'Plébiscité par les investisseurs du monde entier',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Francfort, Allemagne',
  'testimonials.client1.text': 'Excellente plateforme avec une tarification transparente et une exécution fiable. Les fonctions de sécurité m’inspirent une totale confiance.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'Paris, France',
  'testimonials.client2.text': 'Service professionnel et spreads compétitifs. L’équipe d’assistance multilingue est d’une aide remarquable.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Milan, Italie',
  'testimonials.client3.text': 'Exécution rapide et excellents outils d’analyse de marché. Fortement recommandé pour le trading sérieux des métaux précieux.',

  // Footer
  'footer.company': 'Entreprise',
  'footer.trading': 'Trading',
  'footer.support': 'Assistance',
  'footer.legal': 'Mentions légales',
  'footer.about': 'À propos de nous',
  'footer.careers': 'Carrières',
  'footer.news': 'Actualités',
  'footer.platforms': 'Plateformes de trading',
  'footer.education': 'Formation',
  'footer.analysis': 'Analyse de marché',
  'footer.help': "Centre d'aide",
  'footer.contact': 'Nous contacter',
  'footer.faq': 'FAQ',
  'footer.terms': 'Conditions d’utilisation',
  'footer.privacy': 'Politique de confidentialité',
  'footer.risk': 'Avertissement sur les risques',
  'footer.copyright': '© 2024 GOLD Label Global Limited. Tous droits réservés.',
  'footer.license': "Société constituée à Hong Kong",
  'footer.riskwarning': 'Avertissement sur les risques',
  'footer.disclaimer': 'Le trading sur marge est un produit financier à effet de levier pouvant entraîner des pertes supérieures à vos dépôts. Vous ne détenez ni ne possédez réellement aucun actif sous-jacent. Veuillez lire attentivement notre Déclaration de divulgation des risques avant de trader. Assurez-vous de bien comprendre les risques encourus et de gérer prudemment votre exposition. Nous déclinons toute responsabilité pour les actions ou omissions entreprises par toute personne sur la base des informations figurant sur ce site Web ou de son contenu.',
  'footer.jurisdiction': "Avis relatif aux juridictions",
  'footer.jurisdictionDisclaimer': "Les services sont proposés uniquement aux clients éligibles dans des juridictions autres que Hong Kong et les États-Unis, sous réserve que leur fourniture soit autorisée par les lois applicables dans la juridiction du client. Les services ne sont pas proposés aux résidents de Hong Kong ou des États-Unis, ni à toute personne située dans une juridiction où ces services seraient illégaux ou interdits. Ce site Web ne s'adresse pas aux personnes situées dans des juridictions restreintes et ne constitue à leur égard ni une offre, ni une sollicitation, ni une recommandation.",
  'footer.relatedEntity': 'Autre entité liée',
  'footer.saintLuciaEntity': "Gold Label Global (SL) Limited est une International Business Company constituée à Sainte-Lucie le 4 septembre 2026, sous le numéro d'enregistrement 2026-00680. Siège social : Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. Le siège social est maintenu uniquement à des fins de conformité légale et réglementaire. Il ne constitue pas le lieu d'activité opérationnelle de la société et n'est pas utilisé pour les opérations, les visites de clients ou la correspondance.",
  'footer.regNo': "Numéro d’enregistrement de l’entreprise",

  // Common
  'common.language': 'Langue',
  'common.loading': 'Chargement…',
  'common.error': 'Erreur',
  'common.success': 'Succès',
  'common.close': 'Fermer',
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.continue': 'Continuer',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.previous': 'Précédent',
  'common.submit': 'Envoyer',
  'common.reset': 'Réinitialiser',

  // About
  'about.yearsOfExp': "Années d’expérience",
  'about.yearsOfExp.desc': 'Des décennies d’expertise dans le trading des métaux précieux',
  'about.dailyTrade': 'Volume quotidien de trading',
  'about.dailyTrade.desc': '80 milliards HKD de transactions quotidiennes sur l’or et l’argent',
  'about.satClients': 'Clients satisfaits',
  'about.satClients.desc': 'Au service d’innombrables clients et institutions dans le monde',
  'about.exeSpeed': "Vitesse d’exécution",
  'about.exeSpeed.desc': 'Technologie d’exécution ultra-rapide',
  'about.ourAch': 'Nos réalisations',
  'about.ourAch.desc': 'Excellence reconnue dans le trading des métaux précieux avec des performances de premier plan',
  'about.companyProfile': "Profil de l’entreprise",
  'about.about1': 'À propos de Gold Label Global',
  'about.about2': "Gold Label Global Limited est une société à responsabilité limitée enregistrée et approuvée par le gouvernement de Hong Kong, et membre de la Chinese Gold and Silver Exchange Society. Hong Kong traite chaque jour des transactions sur l’or et l’argent d’une valeur de 80 milliards HKD, avec une expérience leader au niveau mondial.",
  'about.about3': "L’équipe de direction de Gold Label Global possède plus de vingt ans d’expérience dédiée au trading de l’or et de l’argent. Nous avons servi d’innombrables clients et institutions, pour un volume de transactions dépassant des dizaines de milliards, et reçu les plus vifs éloges de nos clients et des professionnels du secteur.",
  'about.about4': "Nous nous engageons à offrir à nos clients un environnement de trading rapide, stable et performant. Sur le plan technique, nous adoptons des systèmes de trading de niveau international et sélectionnons des équipes technologiques de premier plan pour développer des solutions plus puissantes et complètes, rendant l’exécution plus rapide, plus stable et plus aboutie.",
  'about.about5': 'Gold Label Global continuera à créer de la valeur avec vous et à partager la prospérité.',
  'about.about6': 'Découvrez notre parcours dans le trading des métaux précieux et notre engagement envers l’excellence sur les marchés financiers mondiaux.',
  'about.about7': "En tant que société à responsabilité limitée enregistrée et approuvée par le gouvernement de Hong Kong, et membre de la Chinese Gold & Silver Exchange Society, nous traitons 80 milliards HKD de transactions quotidiennes sur l’or et l’argent, avec une expertise de premier plan.",
  'about.proTeam': 'Équipe professionnelle',
  'about.proTeam.desc': "Notre équipe de direction cumule plus de 20 ans d’expérience centrée sur le trading de l’or et de l’argent, au service d’innombrables clients et institutions.",
  'about.proService': 'Service professionnel',
  'about.proService.desc': "Équipe client professionnelle proposant une assistance en ligne 24h/24 ainsi qu’un support mobile, et des solutions ciblées aux problèmes des clients.",
  'about.sec': 'La sécurité d’abord',
  'about.sec.desc': 'Aucun intermédiaire de négociation : les ordres sont directement dirigés vers le marché, transparents et sécurisés.',
  'about.strict': 'Supervision stricte',
  'about.strict.desc': 'Gold Label Global est un lieu de négociation commerciale à Hong Kong, réglementé par le gouvernement de Hong Kong et membre de l’Association du commerce commercial de Hong Kong.',
  'about.fastDes': 'Dépôt rapide',
  'about.fastDes.desc': 'Service disponible 24h/24, dépôts en quelques secondes et ouverture de compte instantanée.',
  'about.productSafe': 'Sécurité des produits',
  'about.productSafe.desc': 'Couverture de tous les principaux produits mondiaux en métaux précieux, en toute sécurité.',
  'about.whyGLB': 'Pourquoi choisir Gold Label Global',
  'about.whyGLB.desc': 'Découvrez les atouts qui font de nous le choix numéro un pour le trading des métaux précieux',
  'about.readyToStart': 'Prêt à commencer à trader ?',
  'about.join': 'Rejoignez des milliers de clients satisfaits qui font confiance à GOLD Label Global pour leurs besoins en trading de métaux précieux.',
  'about.openTradingAcc': 'Ouvrir un compte de trading',
  'about.contactTeam': 'Contacter notre équipe',
  'about.co': 'Coopération',
  'about.co.desc': 'Construire des partenariats mutuellement bénéfiques avec nos clients et parties prenantes',
  'about.safety': 'Sécurité',
  'about.safety.desc': 'Garantir le niveau de sécurité le plus élevé pour toutes les activités de trading',
  'about.integrity': 'Intégrité',
  'about.integrity.desc': 'Maintenir les normes les plus élevées d’honnêteté et de transparence',
  'about.professional': 'Professionnalisme',
  'about.professional.desc': 'Fournir des services experts avec un professionnalisme inégalé',
  'about.fast': 'Rapidité',
  'about.fast.desc': 'Assurer une exécution rapide et un service client réactif',
  'about.coreValue': 'Nos valeurs fondamentales',
  'about.coreValue.desc': "Les principes qui guident notre engagement d’excellence dans le trading des métaux précieux",


  // Contact
  'contact.sendUsMsg': 'Envoyez-nous un message',
  'contact.fillOut': 'Remplissez le formulaire ci-dessous et notre équipe vous répondra dans les 24 heures.',
  'contact.inqType': 'Type de demande',
  'contact.genInq': 'Demande générale',
  'contact.accSup': 'Assistance de compte',
  'contact.traSup': 'Assistance au trading',
  'contact.techSup': 'Assistance technique',
  'contact.partner': 'Partenariat',
  'contact.fullname': 'Nom complet *',
  'contact.email': 'Adresse e-mail *',
  'contact.phone': 'Numéro de téléphone',
  'contact.subject': 'Sujet *',
  'contact.msg': 'Message *',
  'contact.sendMsg': 'Envoyer le message',
  'contact.whyUs': 'Pourquoi nous choisir ?',
  'contact.regSec': 'Réglementé et sécurisé',
  'contact.licAndReg': 'Environnement de trading agréé et réglementé, avec des mesures de sécurité avancées pour protéger vos investissements.',
  'contact.expSup': 'Assistance experte',
  'contact.proService': 'Spécialistes du trading disponibles 24h/24 et 7j/7 pour répondre à vos besoins et questions de trading.',
  'contact.fastExe': 'Exécution rapide',
  'contact.lightFast': 'Exécution des ordres ultra-rapide avec un glissement minimal pour des performances optimales.',
  'contact.glbNet': 'Marchés mondiaux',
  'contact.asscessToint': 'Accès aux marchés internationaux des métaux précieux avec des spreads compétitifs et une liquidité élevée.',
  'contact.followUs': 'Suivez-nous sur les réseaux sociaux :',
  'contact.contactOutPro': 'Contactez notre équipe professionnelle pour toute assistance en trading, aide au compte ou demande générale :',
  'contact.officeAddress': 'Adresse du bureau',
  'contact.bussHour': 'Heures d’ouverture : Lun-Ven 9h00–18h00 (GMT+8)',
  'contact.phoneSupp': 'Assistance téléphonique',
  'contact.mainOffice': 'Siège social',
  'contact.availableServices': 'Services disponibles :',
  'contact.accOpenSup': 'Assistance à l’ouverture de compte',
  'contact.tradSup': 'Assistance sur la plateforme de trading',
  'contact.genSup': 'Assistance générale',
  'contact.emailSup': 'Assistance par e-mail',
  'contact.responseTime': 'Délai de réponse :',
  'contact.genInq24': 'Demandes générales : sous 24 heures',
  'contact.techSup24': 'Assistance technique : sous 4 heures',
  'contact.accIss24': 'Problèmes de compte : sous 2 heures',
  'contact.needImSup': 'Besoin d’une assistance immédiate ?',
  'contact.needImSup.desc': 'Nos spécialistes du trading sont disponibles 24h/24 et 7j/7 pour vous aider sur les questions urgentes et le support de compte.',
  'contact.callNow': 'Appeler maintenant',
  'contact.sendEmail': 'Envoyer un e-mail',
  'contact.contactUs': 'Contactez-nous',
  'contact.getInTouch': 'Contactez notre équipe professionnelle du trading. Nous sommes là pour vous aider à réussir dans le trading des métaux précieux.',
  'contact.247Sup': 'Assistance 24h/24',
  'contact.247Sup.desc': 'Service client disponible en continu pour tous vos besoins de trading',
  'contact.dirLine': 'Ligne directe',
  'contact.dirLine.desc': 'Parlez directement à nos spécialistes du trading',
  'contact.hkOffice': 'Bureau de Hong Kong',
  'contact.hkOffice.desc': 'Situé au cœur du quartier financier de Hong Kong',

  // Platform
  'platform.wco': 'Pourquoi choisir notre plateforme MT5 ?',
  'platform.etd': 'Découvrez la différence avec notre plateforme premium conçue pour les traders exigeants',
  'platform.rts': 'Prêt à commencer à trader ?',
  'platform.jto': 'Rejoignez des milliers de traders qui font confiance à notre plateforme pour leurs opérations sur les métaux précieux',
  'platform.ola': 'Ouvrir un compte réel',
  'platform.tda': 'Essayer un compte démo',
  'platform.dmt': 'Télécharger la plateforme MT5',
  'platform.ayt': 'Accédez à votre compte de trading depuis n’importe quel appareil grâce à nos applications MT5 multi-plateformes',
  'platform.free': 'Gratuit',
  'platform.dn': 'Télécharger maintenant',
  'platform.sr': 'Configuration requise',
  'platform.nh': 'Besoin d’aide pour démarrer ?',
  'platform.os': 'Notre équipe d’assistance est prête à vous aider à configurer et à commencer à trader',
  'platform.ug': 'Guide utilisateur',
  'platform.cs': 'Contacter le support',
  'platform.si': 'Connexion Internet stable requise',
  'platform.ptf': 'Fonctionnalités de trading puissantes',
  'platform.epg': 'Découvrez des outils de trading professionnels conçus pour les débutants comme pour les traders expérimentés',
  'platform.ac': 'Graphiques avancés',
  'platform.pct': 'Outils de graphique professionnels avec plus de 80 indicateurs techniques et plusieurs unités de temps pour une analyse complète du marché.',
  'platform.lfe': 'Exécution ultra-rapide',
  'platform.ull': 'Trading à très faible latence avec des vitesses d’exécution pouvant atteindre 0,01 seconde pour des entrées et sorties de position optimales.',
  'platform.ea': 'Expert Advisors (EAs)',
  'platform.atc': 'Capacités de trading automatisé avec Expert Advisors personnalisés et stratégies algorithmiques.',
  'platform.rm': 'Gestion des risques',
  'platform.crm': 'Outils complets de gestion des risques incluant stop loss, take profit et contrôle de la taille des positions.',
  'platform.mpa': 'Accès multi-plateforme',
  'platform.tsa': 'Tradez sans interruption sur ordinateur, web et mobile avec un accès synchronisé à votre compte.',
  'platform.gm': 'Marchés mondiaux',
  'platform.ati': 'Accès aux marchés internationaux, y compris métaux précieux, forex, indices et matières premières.',
  'platform.etw': 'Découvrez la plateforme de trading la plus avancée au monde. Tradez métaux précieux, forex et CFD avec une technologie de niveau institutionnel et une exécution ultra-rapide.',
  'platform.download': 'Télécharger ',
  'platform.wd': 'Regarder la démo',
  'platform.es': "Vitesse d'exécution",
  'platform.th': 'Heures de trading',
  'platform.in': 'Instruments',
  'platform.lt': 'Trading en direct',
  'platform.ptt': 'Outils de trading professionnels',
  'platform.aig': 'Accédez à des outils de trading de niveau institutionnel conçus pour les traders professionnels et les investisseurs sérieux',
  'platform.rtd': 'Données en temps réel',
  'platform.lmd': 'Cours de marché en direct et mises à jour instantanées des prix',
  'platform.pa': 'Alertes de prix',
  'platform.caf': 'Alertes personnalisées sur les mouvements de prix et les événements de marché',
  'platform.this': 'Historique des transactions',
  'platform.cth': 'Historique de trading complet et analyses de performance',
  'platform.ec': 'Calendrier économique',
  'platform.suw': 'Restez informé des événements économiques importants',
  'platform.mw': 'Suivi du marché',
  'platform.rtp': 'Cotations en temps réel et profondeur du marché pour tous les instruments disponibles',
  'platform.om': 'Gestion des ordres',
  'platform.aot': 'Types d’ordres avancés : marché, limite, stop et stop suiveur',
  'platform.ta': 'Analyse technique',
  'platform.cta': 'Outils complets d’analyse technique avec indicateurs personnalisés et outils de dessin',
  'platform.ufe': 'Exécution ultra-rapide',
  'platform.rtc': 'Assistance client disponible 24h/24 par nos experts en trading et spécialistes techniques',
  'platform.247a': 'Disponible 24h/24',
  'platform.csp': 'Spreads compétitifs',
  'platform.iia': 'Spreads parmi les meilleurs du marché et tarification transparente sans frais cachés ni commissions',
  'platform.01pip': 'À partir de 0,1 pip',
  'platform.ffd': 'Application complète pour ordinateur Windows 10/11',
  'platform.nma': 'Application native macOS avec toutes les fonctionnalités',
  'platform.mta': 'Application mobile de trading pour appareils Android',
  'platform.iai': 'Application de trading pour iPhone et iPad',
// FAQ SECTION
  'faq.tagline': 'COMMENT POUVONS-NOUS VOUS AIDER ?',
  'faq.title': 'Comment pouvons-nous vous aider ?',
  'faq.subtitle': 'Parcourez notre section FAQ complète pour trouver rapidement des réponses à vos questions',
  'faq.categories': 'Catégories',

  // Footer help box
  'faq.cantFind': 'Vous ne trouvez pas ce que vous cherchez ?',
  'faq.supportText': 'Notre équipe d’assistance est là pour répondre à toutes vos questions non couvertes dans la FAQ.',
  'faq.contactSupport': 'Contacter l’équipe d’assistance',

  // Category titles
  'faq.general': 'Général',
  'faq.account': 'Compte',
  'faq.trading': 'Trading',
  'faq.platform': 'Plateforme',
  'faq.deposits': 'Dépôts et retraits',
  'faq.security': 'Sécurité',

  // ─────────── General ───────────
  'faq.general.q1': 'Qu’est-ce que GOLD LABEL GLOBAL LIMITED ?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED est une société de trading de métaux précieux réglementée, basée à Hong Kong, offrant des services professionnels de trading sur l’or, l’argent et d’autres métaux précieux via la plateforme MT5.',
  'faq.general.q2': 'Quels instruments de trading proposez-vous ?',
  'faq.general.a2': 'Nous proposons une large gamme de métaux précieux, notamment l’or au comptant (XAU/USD), l’argent au comptant (XAG/USD), le platine, le palladium et divers contrats à terme sur métaux précieux.',
  'faq.general.q3': 'Quelles sont vos heures de trading ?',
  'faq.general.a3': 'Nos marchés des métaux précieux sont ouverts 24h/24, 5 jours sur 7, du dimanche 17h00 EST au vendredi 16h00 EST, selon les horaires internationaux.',
  'faq.general.q4': 'Mon investissement est-il en sécurité avec votre entreprise ?',
  'faq.general.a4': 'Oui, nous sommes entièrement réglementés et agréés. Les fonds des clients sont séparés et conservés dans des comptes bancaires sécurisés. Nous maintenons également une couverture d’assurance complète pour une protection supplémentaire.',

  // ─────────── Account ───────────
  'faq.account.q1': 'Comment ouvrir un compte de trading ?',
  'faq.account.a1': 'Vous pouvez ouvrir un compte en ligne en remplissant notre formulaire, en fournissant les documents d’identification requis et en effectuant un dépôt initial. Le processus prend généralement 1 à 2 jours ouvrables.',
  'faq.account.q2': 'Quel est le dépôt minimum requis ?',
  'faq.account.a2': 'Le dépôt initial minimum est de 1 000 USD pour un compte standard. Nous proposons également des comptes premium avec des dépôts plus élevés et des avantages supplémentaires.',
  'faq.account.q3': 'Puis-je avoir plusieurs comptes de trading ?',
  'faq.account.a3': 'Oui, vous pouvez ouvrir plusieurs comptes avec différentes devises de base ou types de comptes pour adapter vos stratégies et votre gestion du risque.',
  'faq.account.q4': 'Comment vérifier mon compte ?',
  'faq.account.a4': 'La vérification du compte nécessite une pièce d’identité officielle (passeport ou permis de conduire) et une preuve d’adresse (facture de service public ou relevé bancaire) datant de moins de 3 mois.',

  // ─────────── Trading ───────────
  'faq.trading.q1': 'Quelle est la taille minimale d’un trade ?',
  'faq.trading.a1': 'La taille minimale d’un trade est de 0,01 lot pour la plupart des instruments sur métaux précieux, permettant une gestion du risque flexible pour tous les niveaux de traders.',
  'faq.trading.q2': 'Quel effet de levier proposez-vous ?',
  'faq.trading.a2': 'Nous proposons un effet de levier compétitif jusqu’à 1:100 pour le trading sur métaux précieux, vous permettant d’optimiser votre potentiel tout en maintenant une gestion du risque responsable.',
  'faq.trading.q3': 'Y a-t-il des frais de trading ?',
  'faq.trading.a3': 'Nous fonctionnons sur un modèle basé sur le spread sans frais de commission. Nos spreads sont compétitifs et transparents, sans coûts cachés ni frais imprévus.',
  'faq.trading.q4': 'Puis-je utiliser des stratégies de trading automatisées ?',
  'faq.trading.a4': 'Oui, notre plateforme MT5 prend entièrement en charge les Expert Advisors (EAs) et les stratégies automatisées. Vous pouvez développer vos propres algorithmes ou utiliser des robots existants.',

  // ─────────── Platform ───────────
  'faq.platform.q1': 'Quelles plateformes de trading supportez-vous ?',
  'faq.platform.a1': 'Nous utilisons principalement MetaTrader 5 (MT5), la plateforme leader du secteur. MT5 est disponible pour ordinateur (Windows/Mac), mobile (iOS/Android) et navigateur web.',
  'faq.platform.q2': 'La plateforme MT5 est-elle gratuite ?',
  'faq.platform.a2': 'Oui, la plateforme MT5 est entièrement gratuite à télécharger et à utiliser. Nous offrons un accès complet à toutes les fonctionnalités, graphiques, indicateurs et outils de trading sans coût supplémentaire.',
  'faq.platform.q3': 'Puis-je trader sur mobile ?',
  'faq.platform.a3': 'Absolument ! Nos applications MT5 pour iOS et Android offrent une fonctionnalité complète, des graphiques en temps réel, des actualités de marché et la gestion de votre compte où que vous soyez.',
  'faq.platform.q4': 'Proposez-vous des comptes démo ?',
  'faq.platform.a4': 'Oui, nous proposons des comptes démo gratuits avec des fonds virtuels afin que vous puissiez vous entraîner et vous familiariser avec la plateforme avant d’investir de l’argent réel.',

  // ─────────── Deposits & Withdrawals ───────────
  'faq.deposits.q1': 'Quels moyens de dépôt acceptez-vous ?',
  'faq.deposits.a1': 'Nous acceptons les virements bancaires, les cartes de crédit/débit (Visa, MasterCard) et divers moyens de paiement électroniques. Tous les dépôts sont traités de manière sécurisée et efficace.',
  'faq.deposits.q2': 'Combien de temps prend le traitement d’un dépôt ?',
  'faq.deposits.a2': 'Les dépôts par carte sont généralement instantanés, tandis que les virements bancaires prennent 1 à 3 jours ouvrables. Les paiements électroniques sont généralement traités en quelques heures.',
  'faq.deposits.q3': 'Y a-t-il des frais de dépôt ?',
  'faq.deposits.a3': 'Nous ne facturons aucun frais pour la plupart des méthodes de dépôt. Cependant, votre banque ou prestataire de paiement peut appliquer ses propres frais.',
  'faq.deposits.q4': 'Comment retirer mes fonds ?',
  'faq.deposits.a4': 'Les retraits peuvent être demandés via votre portail client. Les fonds sont généralement renvoyés par la même méthode utilisée pour le dépôt, avec des délais variables selon le mode de paiement.',

  // ─────────── Security ───────────
  'faq.security.q1': 'Comment protégez-vous mes informations personnelles ?',
  'faq.security.a1': 'Nous utilisons un chiffrement de niveau bancaire (SSL 256 bits) pour sécuriser toutes les transmissions de données. Vos informations sont stockées en toute sécurité et jamais partagées sans votre consentement.',
  'faq.security.q2': 'Proposez-vous une authentification à deux facteurs ?',
  'faq.security.a2': 'Oui, nous recommandons fortement d’activer la vérification en deux étapes (2FA) pour votre compte. Cela ajoute une couche supplémentaire de sécurité contre tout accès non autorisé.',
  'faq.security.q3': 'Que se passe-t-il si j’oublie mon mot de passe ?',
  'faq.security.a3': 'Vous pouvez réinitialiser votre mot de passe via le lien « Mot de passe oublié » sur la page de connexion. Un lien sécurisé de réinitialisation vous sera envoyé par e-mail.',
  'faq.security.q4': 'Comment garantissez-vous des conditions de trading équitables ?',
  'faq.security.a4': 'Nous proposons des prix transparents avec des flux de marché en temps réel, sans intervention de bureau de négociation, et une conformité stricte pour assurer un trading équitable et éthique pour tous nos clients.',

  // Hero
  'hero.browseFAQ': 'Consulter la FAQ',
  'hero.contactSupport': 'Contacter le support',

  // Contact CTA
  'contactCTA.phoneTitle': 'Assistance téléphonique',
  'contactCTA.phoneDesc': 'Parlez directement à nos spécialistes',
  'contactCTA.callNow': 'Appeler maintenant',

  'contactCTA.emailTitle': 'Assistance par e-mail',
  'contactCTA.emailDesc': 'Obtenez des réponses détaillées par écrit',
  'contactCTA.sendMsg': 'Envoyer un message',

  'contactCTA.chatTitle': 'Chat en direct',
  'contactCTA.chatDesc': 'Assistance par messagerie instantanée',
  'contactCTA.available': 'Disponible 24h/24',
  'contactCTA.startChat': 'Démarrer le chat',

  'contactCTA.title': 'Besoin d’aide supplémentaire ?',
  'contactCTA.subtitle': 'Notre équipe d’experts est disponible 24h/24 et 7j/7 pour répondre à toutes vos questions et préoccupations.',
  "androidDownload.title": "Télécharger MetaTrader 5",
  "androidDownload.description": "Vous serez automatiquement redirigé vers Google Play. Si Google Play n’est pas disponible sur votre appareil, vous pouvez télécharger directement l’APK.",
  "androidDownload.autoRedirect": "Redirection vers Google Play dans {{seconds}} secondes",
  "androidDownload.openGooglePlay": "Ouvrir Google Play",
  "androidDownload.downloadApk": "Télécharger l’APK directement",
  "androidDownload.hint": "Si Google Play ne s’ouvre pas, veuillez appuyer sur « Télécharger l’APK directement ».",
  'windowsDownload.pageTitle': 'Télécharger Windows MT5',
  'windowsDownload.pageDesc': 'Veuillez choisir la version d’installation qui vous convient.',
  'windowsDownload.badge': 'Téléchargement Windows MT5',
  'windowsDownload.title': 'Choisissez votre package d’installation',
  'windowsDownload.description': 'Veuillez choisir un installateur Windows MT5. La Gold Label Smooth Stable Version est recommandée pour les utilisateurs de Chine continentale et de Hong Kong. Vous pouvez aussi choisir l’installateur officiel.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Recommandé pour les utilisateurs Windows en Chine continentale / à Hong Kong. Les utilisateurs d’autres régions peuvent aussi l’utiliser si l’installateur officiel n’est pas pratique.',
  'windowsDownload.smoothButton': 'Télécharger Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. Installateur officiel MetaQuotes',
  'windowsDownload.officialDesc': 'Lien de téléchargement original. Les utilisateurs Windows en Chine continentale peuvent parfois rencontrer des problèmes d’installation ; les autres régions ne sont pas concernées.',
  'windowsDownload.officialButton': 'Télécharger l’installateur officiel',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Heure de Hong Kong (GMT+8)',
  'calendar.previousDays': '7 jours précédents',
  'calendar.nextDays': '7 jours suivants',
  'calendar.today': 'Aujourd’hui',
  'calendar.jumpToDate': 'Aller à la date',
  'calendar.completeView': 'Vue complète',
  'calendar.allDays': 'Les 7 jours',
  'calendar.events': 'événements',
  'calendar.impactAll': 'Tous les impacts',
  'calendar.impactHigh': 'Élevé',
  'calendar.impactMedium': 'Moyen',
  'calendar.impactLow': 'Faible',
  'calendar.searchPlaceholder': 'Rechercher un événement, un pays ou une devise',
  'calendar.eventsFound': 'événements affichés',
  'calendar.lastUpdated': 'Dernière mise à jour',
  'calendar.loadError': 'Le calendrier économique est temporairement indisponible.',
  'calendar.noEvents': 'Aucun événement économique ne correspond à cette vue.',
  'calendar.tryAnotherDate': 'Choisissez une autre date ou effacez les filtres.',
  'calendar.time': 'Heure',
  'calendar.impact': 'Impact',
  'calendar.released': 'Publié',
  'calendar.pending': 'À venir',
  'calendar.disclaimer': 'Les horaires sont indiqués à l’heure de Hong Kong. Les chiffres peuvent être révisés et sont fournis à titre informatif.',
  'news.tab.newsDesc': 'Dernières actualités des marchés, analyses de l’or et contenus éducatifs',
  'news.tab.calendarDesc': 'Consultez les événements économiques importants et les publications des jours proches',
  'news.autoRefresh': 'Les actualités sont actualisées automatiquement',

  'news.tabs.news': 'Actualités',
  'news.tabs.calendar': 'Calendrier économique',

};

export default common;
